import classNames from 'classnames';

import type { IPublicUser } from '@sravni/types/lib/auth';

import { PhoneNumberChecker } from 'features/PhoneNumberChecker';
import { FullDealEntryPoint } from 'widgets/FullDealEntryPoint';

interface Args {
  isCRMSpecial: string | string[];
  showChecker: boolean;
  isShowCalculator: boolean;
  showHeaders: boolean;
  user: IPublicUser;
}

export const getActions = ({ isCRMSpecial, showChecker, isShowCalculator, showHeaders, user }: Args) => {
  if (isShowCalculator) {
    return <FullDealEntryPoint />;
  }

  if (!isCRMSpecial && showChecker && !user) {
    return <PhoneNumberChecker containerClassName={classNames({ 'h-mt-20': !showHeaders })} />;
  }

  return null;
};
